
  <div class="mob-feedback-card-container">
    <div class="mob-feedback-card" *ngFor="let feedback of VO?.cardFeedBackList; let i = index">
        <div>
            <div class="mob-feedback-card-title">
                <div class="mob-feedback-card__icon">
                    <ng-template  #elseBlock >
                        <span dssIcon [name]="feedback.icon" size="medium"></span>
                    </ng-template>
                    <div *ngIf="feedback.icon == null; else elseBlock">
                        <img [src]="localImagePlace" class="mob-svg-icon" height="42" alt="icone open finance">
                    </div>
                </div>
                <span dssTypography type="h2" class="mob-text--center" >{{ feedback.title }}</span>
            </div>
            <div class="mob-feedback-card-description">
                <span dssTypography type="body"  class="mob-text--center" [innerHTML]="feedback.description"></span>
            </div>
        </div>
        <a
        (click)="sendMonitoringData(feedback.title)"
        [href]="feedback?.subtitle ? feedback.subtitle : 'feedback' "
        [target]="feedback.subtitle ? '_blank' : '_self' " id="feedbackButton{{i}}"
        ><button dssFilledButton [innerHTML]="titleButton(feedback.name)" id="feedbackNameButton{{i}}"></button></a>
    </div>
    <!-- <a *ngFor="let feedback of VO?.cardFeedBackList"
        (click)="sendMonitoringData(feedback.title)"
        [href]="feedback?.subtitle ? feedback.subtitle : 'feedback' "
        [target]="feedback.subtitle ? '_blank' : '_self' "
        class="mob-feedback-card">
            <div class="mob-feedback-card__icon">
                <ng-template  #elseBlock >
                    <span dssIcon [name]="feedback.icon" size="medium"></span>
                </ng-template>
                <div *ngIf="feedback.icon == null; else elseBlock">
                    <img [src]="localImagePlace" class="mob-svg-icon" height="32" alt="icone open finance">
                </div>

            </div>
        <div>
            <span dssTypography type="h2" class="mob-text--bold mob-text--center" >{{ feedback.title }}</span>
            <span dssTypography type="body"  class="mob-text--color mob-text--center" [innerHTML]="feedback.description "></span>
        </div>

    </a> -->
</div>

